import {createTheme} from "@mui/material/styles";
import * as React from "react";
import Responsive from "react-responsive";
import { css } from "styled-components";

// The material ui theme
export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 500,
      md: 960,
      lg: 1086, // ??
      xl: 1920,
    },
  },
  palette: {
    background: {
      default: "#FFF",
    },
    // type: 'dark',
    primary: {
      light: "#F0F0F0",
      main: "#fff",
      dark: "#252F28",
      contrastText: "#DE4A22",
    },
    secondary: {
      main: "#252F28",
      light: "#333333DD",
      dark: "#DE4A22",
      contrastText: "#fff",
    },
    info: {
      main: "#fff",
      contrastText: "#76323F",
    },
  },
  typography: {
    fontFamily: "inherit",
    htmlFontSize: 18,
    button: {
      textTransform: "none",
      fontSize: "1em",
    },
    h1: {
      fontSize: "2.4em",
      fontWeight: "bold",
      /* "@media (min-width:600px)": {
        fontSize: "1.5rem",
      },
    [theme.breakpoints.up("md")]: {
        fontSize: "2.4rem",
      },*/
    },
    h2: {
      fontSize: "2.2rem",
      fontWeight: "bold",
    },
    h3: {
      fontSize: "1.4rem",
      fontWeight: "bold",
    },
    h4: {
      fontSize: "1.1rem",
      fontWeight: "bold",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-outlined' : {
            border: `1px solid rgba(0, 0, 0, 0.23)`,
          }
        },
      }
    }
  }
});

// these sizes are arbitrary and you can set them to whatever you wish
export const Desktop = (props: any) => <Responsive {...props} minWidth={992} />;
export const Tablet = (props: any) => (
  <Responsive {...props} minWidth={768} maxWidth={991} />
);
export const Mobile = (props: any) => <Responsive {...props} maxWidth={767} />;
export const Default = (props: any) => <Responsive {...props} minWidth={768} />;

export const mediaQuerySizes: { [s: string]: number } = {
  giant: 1170,
  desktop: 992,
  tablet: 768,
  phone: 500,
};
interface MediaTypes {
  [key: string]: any;
  giant: (tString: TemplateStringsArray) => TemplateStringsArray;
  desktop: (tString: TemplateStringsArray) => TemplateStringsArray;
  tablet: (tString: TemplateStringsArray) => TemplateStringsArray;
  phone: (tString: TemplateStringsArray) => TemplateStringsArray;
}
// iterate through the sizes and create a media template
export const media: MediaTypes = Object.keys(mediaQuerySizes).reduce<
  MediaTypes
>(
  (accumulator, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = mediaQuerySizes[label] / 16;
    accumulator[label] = (...args: any) => css`
      @media (max-width: ${emSize}em) {
        ${(css as any)(...args)};
      }
    `;
    return accumulator;
  },
  {
    giant: (str: TemplateStringsArray) => str,
    desktop: (str: TemplateStringsArray) => str,
    tablet: (str: TemplateStringsArray) => str,
    phone: (str: TemplateStringsArray) => str,
  }
);
